import React from 'react';
import classNames from 'classnames';
import './SidebarLayoutSidebar.scss';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  stickAt?: number | string | null;
};

const isSticky = (stickAt?: number | string | null): stickAt is number | string =>
  stickAt !== undefined && stickAt !== null;

export const SidebarLayoutSidebar: React.FC<Props> = ({
  className,
  children,
  stickAt,
  ...rest
}) => (
  <div className={classNames('SidebarLayoutSidebar', className)} {...rest}>
    {isSticky(stickAt) ? (
      <div className="SidebarLayoutSidebar__sticky" style={{ top: stickAt }}>
        {children}
      </div>
    ) : (
      children
    )}
  </div>
);
